import type {State} from '../../../../../reducers/types'
import type {ChangeId} from '../../../../../types'
import {notNull} from '../../../../../utils/guards'
import {getChange} from '../../Changes.selectors'

export const getChangesByIds = (state: State, changeIds: readonly ChangeId[]) =>
  changeIds.map(id => getChange(state, id)).filter(notNull)
